import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";
var clickOutside = require("click-outside");

export default class extends Controller {
  static targets = ["modal", "frame", "page"];

  connect() {
    this.element[this.identifier] = this;

    document.addEventListener("turbo:before-fetch-request", (e) => {
      let turboFrame = e.detail.fetchOptions.headers["Turbo-Frame"];

      if (turboFrame == this.identifier) {
        this.open();
      } else if (!turboFrame) {
        this.close({ force: true });
      }
    });

    document.addEventListener("turbo:frame-render", (e) => {
      if (e.target.id == this.identifier) {
        const event = new Event("modal:load");

        document.dispatchEvent(event);
      }
    });

    document.onkeydown = (e) => {
      if (e.key == "Escape") this.close({ force: true });
    };
  }

  error() {
    this.frameTarget.innerHTML = `BOEM`;
  }

  close(e) {
    if (!e.force) e.preventDefault();

    this.data.delete("open");

    if (this.hasPageTarget) {
      if (this.pageTarget.dataset.modalRefresh) {
        window.turboScroll = document.scrollingElement.scrollTop;
        Turbo.visit(window.location);
      }
    }

    this.closeTimeout = setTimeout(() => {
      this.frameTarget.innerHTML = "";
    }, 500);
  }

  open() {
    if (this.closeTimeout) clearTimeout(this.closeTimeout);

    setTimeout(() => {
      this.eventListener = clickOutside(this.frameTarget, (e) => {
        this.eventListener();

        if (e.target.closest(".flatpickr-calendar")) return;

        this.close({ force: true });
      });
    });

    if (this.data.get("open") != "1") {
      this.frameTarget.innerHTML = "";
    }

    this.data.set("open", "1");

    // this.modalTarget.scroll({
    //   top: 0,
    //   behavior: 'smooth'
    // });
  }
}
